/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { useLocation, Link } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import OptimizedImage from '../OptimizedImage'
const $ = require("jquery")
$.Datatable = require("datatables.net");
export default function View() {
    const location = useLocation();
    const path = location.pathname.split("/")[3];
    const [user, setUser] = useState();
    const [item, setVerify] = useState();
    const [challenge, setchallenge] = useState()
    const [challengePage, setChallengePage] = useState(0)
    const [challengeLimit, setChallengeLimit] = useState(10)
    const [challengeTotalPages, setChallengeTotalPages] = useState(0)
    const [challengeStatus, setChallengeStatus] = useState('')
    const [txn, setTxn] = useState()
    const [txnPage, setTxnPage] = useState(0)
    const [txnLimit, setTxnLimit] = useState(10)
    const [txnTotalPages, setTxnTotalPages] = useState(0)
    const [txnwith, setTxnwith] = useState()
    const [txnwithPage, setTxnwithPage] = useState(0)
    const [txnwithLimit, setTxnwithLimit] = useState(10)
    const [txnwithTotalPages, setTxnwithTotalPages] = useState(0)
    const [referral, setReferral] = useState();
    const [referralPage, setReferralPage] = useState(0)
    const [referralLimit, setReferralLimit] = useState(10)
    const [referralTotalPages, setReferralTotalPages] = useState(0)
    const [kyc, setKyc] = useState();
    const [bonusHis, setBonusHis] = useState();
    const [bonusPage, setBonusPage] = useState(0)
    const [bonusLimit, setBonusLimit] = useState(10)
    const [bonusTotalPages, setBonusTotalPages] = useState(0)
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;

    let baseUrl;
    if (nodeMode === "development") {
        baseUrl = beckendLocalApiUrl;
    } else {
        baseUrl = beckendLiveApiUrl;
    }
    if (baseUrl && !baseUrl.endsWith('/')) {
        baseUrl += '/';
    }
    const homeUrl = nodeMode === "development" ? "http://localhost:3001" : "https://unitedludoclub.com";
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    let [mismatchValue, setmismatchValue] = useState(0);
    let [HoldBalance, setHoldBalance] = useState(0);
    const getUser = () => {
        let access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.get(baseUrl + `get_user/${path}`, { headers })
            .then((res) => {
                console.log(res.data);
                setUser(res.data)
                Allrefer(res.data.referral_code)
                setmismatchValue(res.data.Wallet_balance - (((res.data.wonAmount - res.data.loseAmount) + res.data.totalDeposit + res.data.referral_earning + res.data.totalBonus) - (res.data.totalWithdrawl + res.data.referral_wallet + res.data.withdraw_holdbalance + res.data.hold_balance + res.data.totalPenalty)));
                setHoldBalance(res.data.hold_balance);
            }).catch((e) => {
                console.log(e)
            })
    }
    const [referCount, setRefercount] = useState([])
    const Allrefer = async (id) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        await axios.get(baseUrl + `referral/code/${id}`, { headers })
            .then((res) => {
                setRefercount(res.data)
                console.log(res.data)
            })
    }
    const Allchallenge = async (page = 0, limit = challengeLimit, status = challengeStatus) => {
        const access_token = localStorage.getItem('token')
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        let url = baseUrl + `get_challange/user/${path}?page=${page}&_limit=${limit}`;
        if (status) url += `&_status=${status}`;
        axios.get(url, { headers })
            .then((res) => {
                setTxn(undefined)
                setTxnwith(undefined)
                setReferral(undefined)
                setKyc(undefined)
                setBonusHis(undefined)
                setchallenge(res.data.data)
                setChallengeTotalPages(res.data.totalPages)
                setChallengePage(page)
                setChallengeLimit(limit)
                setChallengeStatus(status)
            }).catch((e) => {
                console.log(e)
            })
    }
    const transactionHis = (page = 0, limit = txnLimit) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.get(baseUrl + `txn_history/user/${path}?page=${page}&_limit=${limit}`, { headers })
            .then((res) => {
                setchallenge(undefined);
                setReferral(undefined)
                setKyc(undefined)
                setTxnwith(undefined)
                setBonusHis(undefined)
                setTxn(res.data.admin)
                setTxnTotalPages(res.data.totalPages)
                setTxnPage(page)
                setTxnLimit(limit)
            }).catch((e) => {
                console.log(e)
            })
    }
    const withdrawalHis = (page = 0, limit = txnwithLimit) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.get(baseUrl + `txnwith_history/user/${path}?page=${page}&_limit=${limit}`, { headers })
            .then((res) => {
                setTxn(undefined)
                setchallenge(undefined)
                setReferral(undefined)
                setKyc(undefined)
                setBonusHis(undefined)
                setTxnwith(res.data.admin)
                setTxnwithTotalPages(res.data.totalPages)
                setTxnwithPage(page)
                setTxnwithLimit(limit)
            }).catch((e) => {
                console.log(e)
            })
    }
    const dateFormat = (e) => {
        const date = new Date(e);
        const newDate = date.toLocaleString('default', { month: 'long', day: 'numeric', hour: 'numeric', hour12: true, minute: 'numeric' });
        return newDate;
    }
    const referralHis = async (page = 0, limit = referralLimit) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        await axios.get(baseUrl + `referral/code/winn/${user.referral_code}?page=${page}&_limit=${limit}`, { headers })
            .then((res) => {
                setchallenge(undefined);
                setTxn(undefined)
                setTxnwith(undefined)
                setKyc(undefined);
                setBonusHis(undefined);
                setReferral(res.data.data)
                setReferralTotalPages(res.data.totalPages)
                setReferralPage(page)
                setReferralLimit(limit)
            }).catch((e) => {
                console.log(e)
            })
    }

    const getBonusHistory = (page = 0, limit = bonusLimit) => {
        const access_token = localStorage.getItem("token")
        const headers = { Authorization: `Bearer ${access_token}` }

        // Req_type=bonus filters server-side now (previously fetched deposit-only data and
        // filtered client-side for Req_type === 'bonus', which could never match anything -
        // this tab was always empty before this fix).
        axios.get(baseUrl + `txn_history/user/${path}?page=${page}&_limit=${limit}&Req_type=bonus`, { headers })
            .then((res) => {
                setchallenge(undefined);
                setReferral(undefined)
                setKyc(undefined)
                setTxnwith(undefined)
                setTxn(undefined)
                setBonusHis(res.data.admin);
                setBonusTotalPages(res.data.totalPages)
                setBonusPage(page)
                setBonusLimit(limit)
            }).catch((e) => {
                console.log(e)
            })
    }
    const handleManualDeposit = async (userId) => {
        const amount = document.getElementById("manual_deposit_amount").value;
        if (!amount || amount <= 0) {
            alert("Please enter a valid amount to deposit.");
            return;
        }

        const confirmDep = window.confirm("Are you sure you want to deposit ₹" + amount + " to this user?");
        if (!confirmDep) return;

        const access_token = localStorage.getItem("token")
        const headers = { Authorization: `Bearer ${access_token}` };

        try {
            const res = await axios.post(`${baseUrl}admin/manual_deposit`, { user_id: userId, amount: amount }, { headers });
            if (res.data.status === 'ok') {
                alert(res.data.message);
                document.getElementById("manual_deposit_amount").value = "";
                getUser();
                transactionHis(); // Refresh tables
            }
        } catch (error) {
            console.error("Manual deposit error:", error);
            alert(error.response?.data?.message || "Deposit Failed");
        }
    }

    const getKyc = () => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.get(baseUrl + `admin/user/kyc/${path}`, { headers })
            .then((res) => {
                setTxn(undefined)
                setTxnwith(undefined)
                setReferral(undefined)
                setchallenge(undefined)
                setBonusHis(undefined)
                setKyc(res.data)
                console.log(res.data);
                setTimeout(() => {
                    if ($.fn.DataTable.isDataTable('.kyc-view-table')) $('.kyc-view-table').DataTable().destroy();
                    $('.kyc-view-table').dataTable({ responsive: true });
                    imageViewer();
                }, 500);
            })
    }
    function imageViewer() {
        let imgs = document.getElementsByClassName("img"),
            out = document.getElementsByClassName("img-out")[0];
        if (!out) return;
        for (let i = 0; i < imgs.length; i++) {
            if (!imgs[i].classList.contains("el")) {
                imgs[i].classList.add("el");
                imgs[i].addEventListener("click", lightImage);
                function lightImage() {
                    let container = document.getElementsByClassName("img-panel")[i];
                    if (container) container.classList.toggle("img-panel__selct");
                };
                imgs[i].addEventListener("click", openImage);
                function openImage() {
                    let imgElement = document.createElement("img"),
                        imgWrapper = document.createElement("div"),
                        imgClose = document.createElement("div"),
                        container = imgs[i].parentElement; // Modified to be safe

                    if (container) container.classList.add("img-panel__selct");

                    imgElement.setAttribute("class", "image__selected");
                    imgElement.src = imgs[i].src;
                    imgWrapper.setAttribute("class", "img-wrapper");
                    imgClose.setAttribute("class", "img-close");
                    imgWrapper.appendChild(imgElement);
                    imgWrapper.appendChild(imgClose);
                    setTimeout(function () {
                        imgWrapper.classList.add("img-wrapper__initial");
                        imgElement.classList.add("img-selected-initial");
                    }, 50);
                    out.appendChild(imgWrapper);
                    imgClose.addEventListener("click", function () {
                        if (container) container.classList.remove("img-panel__selct");
                        out.removeChild(imgWrapper);
                    });
                }
            }
        }
    }
    const update = (Id) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.patch(baseUrl + `aadharcard/${Id}`,
            { verified: "verified" },
            { headers })
            .then((res) => {
                getUser();
                getKyc();
            })
    }
    const updateMismatch = (Id) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.patch(baseUrl + `user/missmatch/clear/${Id}`,
            { headers })
            .then((res) => {
                getUser();
                console.log(res);
            })
    }
    const updateHold = (Id) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.patch(baseUrl + `user/Hold/clear/${Id}`,
            { headers })
            .then((res) => {
                getUser();
                console.log(res);
            })
    }
    const toggleIpBlacklist = () => {
        const ip = user?.last_login_ip || user?.registration_ip;
        if (!ip) {
            alert("IP address not found for this user.");
            return;
        }

        const shouldBlock = !user.ip_blacklisted;
        const confirmText = shouldBlock
            ? `Blacklist IP ${ip} for ${user.Name}?`
            : `Remove IP ${ip} from blacklist?`;

        if (!window.confirm(confirmText)) return;

        const access_token = localStorage.getItem("token")
        const headers = { Authorization: `Bearer ${access_token}` }
        axios.post(baseUrl + `admin/ip-blacklist/toggle`, {
            ip,
            userId: user._id,
            active: shouldBlock,
            reason: `Admin action from user view: ${user.Name} (${user.Phone})`
        }, { headers })
            .then(() => getUser())
            .catch((e) => alert(e.response?.data?.msg || "IP blacklist update failed"))
    }
    const shortDevice = (fingerprint) => {
        if (!fingerprint) return "N/A";
        return `${fingerprint.slice(0, 10)}...${fingerprint.slice(-8)}`;
    }
    const deviceLabel = () => {
        const info = user?.device_info || {};
        return [info.device_type, info.browser, info.os].filter(Boolean).join(" / ") || "N/A";
    }
    const toggleDeviceBlacklist = () => {
        const fingerprint = user?.device_fingerprint;
        if (!fingerprint) {
            alert("Device fingerprint not found for this user.");
            return;
        }

        const shouldBlock = !user.device_blacklisted;
        const confirmText = shouldBlock
            ? `Block this device for ${user.Name}?`
            : `Unblock this device?`;

        if (!window.confirm(confirmText)) return;

        const access_token = localStorage.getItem("token")
        const headers = { Authorization: `Bearer ${access_token}` }
        axios.post(baseUrl + `admin/device-blacklist/toggle`, {
            fingerprint,
            userId: user._id,
            active: shouldBlock,
            reason: `Admin action from user view: ${user.Name} (${user.Phone})`
        }, { headers })
            .then(() => getUser())
            .catch((e) => alert(e.response?.data?.msg || "Device blacklist update failed"))
    }
    const impersonateUser = () => {
        if (!window.confirm(`Impersonate ${user.Name} (${user.Phone})? You will be logged in as this user in a new tab.`)) return;
        const access_token = localStorage.getItem("token")
        const headers = { Authorization: `Bearer ${access_token}` }
        axios.post(baseUrl + `admin/impersonate/${user._id}`, {}, { headers })
            .then((res) => {
                window.open(`${homeUrl}/impersonate?token=${encodeURIComponent(res.data.token)}`, "_blank")
            })
            .catch((e) => alert(e.response?.data?.msg || "Impersonate failed"))
    }
    const updatePendingKyc = (Id) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.patch(baseUrl + `user/pandingkyc/clear/${Id}`,
            { headers })
            .then((res) => {
                getUser();
                alert(res.data);
            })
    }
    const checkfailedpayout = (txn_id, referenceId) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.post(baseUrl + `payout/response/api`, { txn_id, referenceId }, { headers })
            .then((res) => {
                const icon = res.data.status == "SUCCESS" ? "success" : "danger";
                const title = res.data.status == "SUCCESS" ? "Withdraw successfully" : "Transaction Proccessing or Failed";
            })
            .catch((e) => {
                if (e.response.status == 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('token');
                    window.location.reload()
                }
            })
    }
    const deletedata = (Id) => {
        const access_token = localStorage.getItem("token")
        const headers = {
            Authorization: `Bearer ${access_token}`
        }
        axios.patch(baseUrl + `aadharcard/${Id}`,
            { verified: "reject" },
            { headers })
            .then((res) => {
                getUser();
                getKyc();
            })
    }
    useEffect(() => {
        getUser();
        Allchallenge(0, challengeLimit);
        getKyc();
        const access_token = localStorage.getItem("token")
        axios.get(baseUrl + `me`, { headers: { Authorization: `Bearer ${access_token}` } })
            .then((res) => setIsSuperAdmin(Boolean(res.data.is_super_admin)))
            .catch((e) => console.log(e))
    }, [])
    // Styles injected for the Reference UI look
    const styles = `
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');
        .admin-mgmt-page { background: #f0f2f5; min-height: 100vh; padding: 20px; font-family: 'Poppins', sans-serif; }
        /* Typography & Colors form Reference */
        .color-primary { color: #57155a; }
        .bg-primary-gradient { background: linear-gradient(45deg, #57155a, #8e44ad); }
        .bg-success-gradient { background: linear-gradient(45deg, #27ae60, #2ecc71); }
        
        /* Headers */
        .mgmt-header { background: #fff; padding: 25px; border-radius: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); margin-bottom: 30px; }
        .page-title { font-weight: 900; color: #2d3436; margin: 0; font-size: 1.5rem; }
        /* Layout Grid */
        .premium-grid { display: grid; grid-template-columns: 1fr; gap: 30px; margin-bottom: 40px; }
        @media(min-width: 992px) { .premium-grid { grid-template-columns: 1fr 1fr; } }
        
        /* Cards */
        .modern-card { background: #fff; border-radius: 20px; overflow: hidden; box-shadow: 0 15px 35px rgba(0,0,0,0.1); height: 100%; display: flex; flex-direction: column; }
        .card-banner { color: white; padding: 15px 25px; font-weight: 700; text-transform: uppercase; letter-spacing: 1px; font-size: 0.9rem; }
        
        /* Lists */
        .p-list { list-style: none; padding: 0; margin: 0; }
        .p-item { display: flex; justify-content: space-between; align-items: center; padding: 12px 20px; border-bottom: 1px solid #f8f9fa; font-size: 0.9rem; flex-wrap: wrap; gap: 10px; }
        .p-item:hover { background: #fcfcfc; }
        .lbl { color: #636e72; font-weight: 500; font-size: 0.85rem; }
        .val { color: #2d3436; font-weight: 600; text-align: right; max-width: 100%; overflow-wrap: break-word; }
        /* Custom Status Badges */
        .status-badge { padding: 4px 10px; border-radius: 6px; font-size: 0.75rem; font-weight: 700; text-transform: uppercase; display: inline-block; }
        .st-success { background: #e8f5e9; color: #2e7d32; }
        .st-danger { background: #ffebee; color: #c62828; }
        .st-info { background: #e3f2fd; color: #1976d2; }
        
        /* Action Buttons */
        .btn-custom { border: none; padding: 8px 16px; border-radius: 8px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: 0.2s; display: inline-block; text-decoration: none; text-align: center; }
        .btn-purple { background: #57155a; color: white; }
        .btn-purple:hover { background: #3a0d3c; transform: translateY(-2px); }
        .btn-red { background: #ffebee; color: #d32f2f; }
        .btn-red:hover { background: #ffcdd2; }
        .btn-green { background: #e8f5e9; color: #2e7d32; } 
        .btn-green:hover { background: #c8e6c9; }
        .btn-outline { background: white; border: 1px solid #eee; color: #666; }
        .btn-outline:hover { background: #f9f9f9; color: #333; }
        .btn-active { background: #57155a; color: white; border: 1px solid #57155a; }
        /* Quick Actions Area */
        .quick-tools { padding: 20px; background: #fafafa; border-top: 1px solid #eee; margin-top: auto; }
        .tool-row { display: flex; justify-content: space-between; align-items: center; background: white; border: 1px solid #eee; padding: 10px 15px; border-radius: 10px; margin-bottom: 10px; }
        
        /* Image Viewer CSS */
        .img-out { position: fixed; top:0; left:0; z-index: 9999; }
        .img-wrapper { position: fixed; top:0; left:0; width:100vw; height:100vh; background:rgba(0,0,0,0.9); z-index:10000; display:flex; align-items:center; justify-content:center; opacity:0; transition:0.3s; }
        .img-wrapper__initial { opacity:1; }
        .image__selected { max-width:90%; max-height:90vh; border-radius:10px; transform:scale(0.9); transition:0.3s; }
        .img-selected-initial { transform:scale(1); }
        .img-close { position:absolute; top:20px; right:20px; width:40px; height:40px; background:rgba(255,255,255,0.2); border-radius:50%; cursor:pointer; }
        .img-close::before, .img-close::after { content:''; position:absolute; top:19px; left:10px; width:20px; height:2px; background:white; transform:rotate(45deg); }
        .img-close::after { transform:rotate(-45deg); }
        /* Table & DataTables */
        .table-card { background: #fff; border-radius: 20px; padding: 20px; box-shadow: 0 10px 30px rgba(0,0,0,0.05); margin-top: 20px; }
        .table-responsive { overflow-x: auto; -webkit-overflow-scrolling: touch; }
        table.dataTable, .user-view-table { width: 100% !important; border-collapse: collapse !important; }
        table.dataTable thead th, .user-view-table thead th { background: #f8f9fa; color: #636e72; font-weight: 700; text-transform: uppercase; font-size: 0.8rem; padding: 15px !important; border-bottom: 2px solid #eee !important; }
        table.dataTable tbody td, .user-view-table tbody td { padding: 15px !important; border-bottom: 1px solid #f1f1f1 !important; vertical-align: middle; color: #2d3436; font-size: 0.9rem; }
        .dataTables_wrapper .dataTables_paginate .paginate_button.current { background: #57155a !important; color: white !important; border: 1px solid #57155a !important; border-radius: 5px; }
        .tab-toolbar { display: flex; flex-wrap: wrap; gap: 10px; align-items: center; margin-bottom: 15px; }
        .tab-toolbar select { padding: 6px 10px; border-radius: 6px; border: 1px solid #eee; font-size: 0.85rem; }
        .pagination-wrapper { display: flex; justify-content: center; margin-top: 15px; }
        .pagination-wrapper ul { list-style: none; display: flex; gap: 5px; padding: 0; margin: 0; flex-wrap: wrap; }
        .pagination-wrapper li a { display: block; padding: 6px 12px; border-radius: 6px; border: 1px solid #eee; color: #57155a; cursor: pointer; font-size: 0.85rem; }
        .pagination-wrapper li.active a { background: #57155a; color: #fff; border-color: #57155a; }
        .pagination-wrapper li.disabled a { color: #ccc; cursor: not-allowed; }
        /* Utility */
        .text-green { color: #27ae60; font-weight: 700; }
        .text-red { color: #c62828; font-weight: 700; }
        .mr-2 { margin-right: 10px; }
        .mb-3 { margin-bottom: 10px; }
        .prof-img { width: 80px; height: 80px; border-radius: 50%; object-fit: cover; border: 3px solid #fff; box-shadow: 0 5px 15px rgba(0,0,0,0.1); }
    `;
    return (
        <div className="admin-mgmt-page">
            <style>{styles}</style>

            <div className="img-out"></div>
            {Boolean(user) && (
                <>
                    {/* Header */}
                    <div className="mgmt-header">
                        <h2 className="page-title">User <span className="color-primary">Details View</span></h2>
                    </div>
                    {/* Main Grid */}
                    <div className="premium-grid">

                        {/* Left Card: User Info directly mapped */}
                        <div className="modern-card">
                            <div className="card-banner bg-primary-gradient">Personal & Wallet Info</div>
                            <ul className="p-list">
                                {(user && user.avatar) && (
                                    <li className="p-item" style={{ justifyContent: 'center', background: '#fafafa' }}>
                                        <div className="img-panel">
                                            <OptimizedImage 
                                                className="img prof-img" 
                                                src={baseUrl + `${user.avatar}`} 
                                                alt="Profile" 
                                                width="80px"
                                                height="80px"
                                                style={{borderRadius: '50%'}}
                                            />
                                        </div>
                                    </li>
                                )}
                                <li className="p-item"><span className="lbl">Name</span><span className="val">{user.Name}</span></li>
                                <li className="p-item"><span className="lbl">Verified</span><span className={`status-badge ${user.verified === "verified" ? 'st-success' : 'st-danger'}`}>{user.verified}</span></li>
                                <li className="p-item"><span className="lbl">Phone</span><span className="val">{user.Phone}</span></li>
                                <li className="p-item">
                                    <span className="lbl">Last IP</span>
                                    <span className={`val ${user.ip_blacklisted ? 'text-red' : ''}`}>
                                        {user.last_login_ip || "N/A"} {user.ip_blacklisted ? "(BLACKLISTED)" : ""}
                                    </span>
                                </li>
                                <li className="p-item"><span className="lbl">Register IP</span><span className="val">{user.registration_ip || "N/A"}</span></li>
                                <li className="p-item">
                                    <span className="lbl">Device ID</span>
                                    <span className={`val ${user.device_blacklisted ? 'text-red' : ''}`}>
                                        {shortDevice(user.device_fingerprint)} {user.device_blacklisted ? "(BLOCKED)" : ""}
                                    </span>
                                </li>
                                <li className="p-item"><span className="lbl">Device Type</span><span className="val">{user.device_info?.device_type || "N/A"}</span></li>
                                <li className="p-item"><span className="lbl">Browser</span><span className="val">{user.device_info?.browser || "N/A"}</span></li>
                                <li className="p-item"><span className="lbl">OS</span><span className="val">{user.device_info?.os || "N/A"}</span></li>
                                <li className="p-item"><span className="lbl">Device Summary</span><span className="val">{deviceLabel()}</span></li>

                                <li className="p-item"><span className="lbl">Wallet Balance</span><span className="val text-green">₹{user.Wallet_balance}</span></li>
                                <li className="p-item"><span className="lbl">Withdrawal Amount</span><span className="val">₹{user.withdrawAmount}</span></li>
                                <li className="p-item"><span className="lbl">Withdrawal Hold</span><span className="val text-red">₹{user.withdraw_holdbalance}</span></li>
                                <li className="p-item text-center" style={{ display: 'block' }}><div style={{ fontSize: '0.75rem', color: '#999' }}>Note: If hold balance not 0 user can't make new Withdrawal request</div></li>
                                <li className="p-item"><span className="lbl">Referral Balance</span><span className="val">{user.referral_wallet}</span></li>
                                <li className="p-item"><span className="lbl">Referral Count</span><span className="val">{referCount && referCount}</span></li>
                                <li className="p-item"><span className="lbl">Referral Earning</span><span className="val">{user.referral_earning}</span></li>
                                <li className="p-item"><span className="lbl">Total Deposit</span><span className="val">{user.totalDeposit}</span></li>
                                <li className="p-item"><span className="lbl">Total Withdrawal</span><span className="val">{user.totalWithdrawl}</span></li>
                                <li className="p-item"><span className="lbl">Total Bonus</span><span className="val">{user.totalBonus}</span></li>
                                <li className="p-item"><span className="lbl">Total Penalty</span><span className="val">{user.totalPenalty}</span></li>
                                <li className="p-item"><span className="lbl">Hold Balance</span><span className="val">{HoldBalance}</span></li>
                                <li className="p-item"><span className="lbl">Won Amount</span><span className="val">{user.wonAmount}</span></li>
                                <li className="p-item"><span className="lbl">Lose Amount</span><span className="val">{user.loseAmount}</span></li>
                                <li className="p-item"><span className="lbl">Calculated Bal</span><span className="val">{((user.wonAmount - user.loseAmount) + user.totalDeposit + user.referral_earning + user.totalBonus) - (user.totalWithdrawl + user.referral_wallet + user.withdraw_holdbalance + user.hold_balance + user.totalPenalty)}</span></li>
                                <li className="p-item"><span className="lbl">Mismatch Bal</span><span className="val text-red">{mismatchValue}</span></li>
                                <li className="p-item"><span className="lbl">Referral Code</span><span className="val">{user.referral_code}</span></li>
                                <li className="p-item">
                                    <span className="lbl">Referral By</span>
                                    <span className="val" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        {user.referral || "N/A"}
                                        <button
                                            className="btn-custom btn-purple"
                                            style={{ padding: '2px 8px', fontSize: '0.7rem' }}
                                            onClick={() => {
                                                const newRef = prompt("Enter new Referral Code:", user.referral || "");
                                                if (newRef !== null && newRef !== user.referral) {
                                                    // Call update API
                                                    const access_token = localStorage.getItem("token");
                                                    const headers = { Authorization: `Bearer ${access_token}` };
                                                    axios.patch(baseUrl + `admin/user/edit/${user._id}`, { referral: newRef }, { headers })
                                                        .then(res => {
                                                            alert("Referral Updated!");
                                                            getUser(); // Refresh
                                                        })
                                                        .catch(err => alert("Failed to update"));
                                                }
                                            }}
                                        >Edit</button>
                                    </span>
                                </li>
                                <li className="p-item"><span className="lbl">Created At</span><span className="val">{dateFormat(user.createdAt).split(',')[0]}</span></li>
                                <li className="p-item"><span className="lbl">Updated At</span><span className="val">{dateFormat(user.updatedAt).split(',')[0]}</span></li>
                            </ul>
                        </div>
                        {/* Right Card: Bank & Actions */}
                        <div className="modern-card">
                            <div className="card-banner bg-success-gradient">Bank & Quick Actions</div>
                            <ul className="p-list">
                                <li className="p-item"><span className="lbl">Account Holder</span><span className="val">{user.holder_name}</span></li>
                                <li className="p-item"><span className="lbl">IFSC Code</span><span className="val">{user.ifsc_code}</span></li>
                                <li className="p-item"><span className="lbl">Account Number</span><span className="val">{user.account_number}</span></li>
                                <li className="p-item"><span className="lbl">UPI ID</span><span className="val">{user.upi_id}</span></li>
                            </ul>
                            <div className="quick-tools">
                                <h4 style={{ fontSize: '0.85rem', color: '#666', marginBottom: '10px', textTransform: 'uppercase' }}>Management Tools</h4>

                                <div className="tool-row">
                                    <div><span className="lbl">Mismatch ({mismatchValue})</span></div>
                                    <button onClick={() => updateMismatch(user._id)} className="btn-custom btn-green">CLEAR</button>
                                </div>

                                <div className="tool-row">
                                    <div><span className="lbl">Hold ({HoldBalance})</span></div>
                                    <button onClick={() => updateHold(user._id)} className="btn-custom btn-green">CLEAR</button>
                                </div>
                                <div className="tool-row">
                                    <div><span className="lbl">Pending KYC</span></div>
                                    <button onClick={() => updatePendingKyc(user._id)} className="btn-custom btn-red">CLEAR KYC</button>
                                </div>
                                <div className="tool-row">
                                    <div><span className="lbl">IP Blacklist</span></div>
                                    <button onClick={toggleIpBlacklist} className={`btn-custom ${user.ip_blacklisted ? 'btn-green' : 'btn-red'}`}>
                                        {user.ip_blacklisted ? "IP UNBLOCK" : "IP BLOCK"}
                                    </button>
                                </div>
                                <div className="tool-row">
                                    <div><span className="lbl">Device Blacklist</span></div>
                                    <button onClick={toggleDeviceBlacklist} className={`btn-custom ${user.device_blacklisted ? 'btn-green' : 'btn-red'}`}>
                                        {user.device_blacklisted ? "DEVICE UNBLOCK" : "DEVICE BLOCK"}
                                    </button>
                                </div>
                                {isSuperAdmin && (
                                    <div className="tool-row">
                                        <div><span className="lbl">Impersonate</span></div>
                                        <button onClick={impersonateUser} className="btn-custom btn-purple">LOG IN AS USER</button>
                                    </div>
                                )}
                                <div className="tool-row" style={{ flexDirection: 'column', alignItems: 'flex-start', background: '#ffebee', padding: '10px', borderRadius: '5px', marginTop: '10px' }}>
                                    <h5 style={{ fontSize: '13px', margin: '0 0 5px 0', color: '#c62828' }}><b>Manual Deposit (Admin Only)</b></h5>
                                    <div style={{ display: 'flex', gap: '5px', width: '100%' }}>
                                        <input type="number" id="manual_deposit_amount" placeholder="Amount (₹)" style={{ flex: 1, padding: '5px', border: '1px solid #ffcdd2', borderRadius: '3px' }} />
                                        <button onClick={() => handleManualDeposit(user._id)} className="btn-custom btn-green" style={{ background: '#c62828' }}>DEPOSIT</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Action Tabs for Tables */}
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', marginBottom: '20px' }}>
                        <button className={`btn-custom ${Boolean(challenge) ? 'btn-purple' : 'btn-outline'}`} onClick={() => Allchallenge(0, challengeLimit, challengeStatus)}>Game History</button>
                        <button className={`btn-custom ${Boolean(txn) ? 'btn-purple' : 'btn-outline'}`} onClick={() => transactionHis(0, txnLimit)}>Deposit History</button>
                        <button className={`btn-custom ${Boolean(txnwith) ? 'btn-purple' : 'btn-outline'}`} onClick={() => withdrawalHis(0, txnwithLimit)}>Withdrawal History</button>
                        <button className={`btn-custom ${Boolean(referral) ? 'btn-purple' : 'btn-outline'}`} onClick={() => referralHis(0, referralLimit)}>Referral History</button>
                        <button className={`btn-custom ${Boolean(bonusHis) ? 'btn-purple' : 'btn-outline'}`} onClick={() => getBonusHistory(0, bonusLimit)}>Bonus History</button>
                        <button className={`btn-custom ${Boolean(kyc) ? 'btn-purple' : 'btn-outline'}`} onClick={getKyc}>KYC</button>
                    </div>
                    {/* Tables Container */}
                    <div className="table-card">

                        {/* 1. Game History */}
                        {Boolean(challenge) && (
                            <div>
                                <div className="tab-toolbar">
                                    <select value={challengeStatus} onChange={(e) => Allchallenge(0, challengeLimit, e.target.value)}>
                                        <option value="">All Statuses</option>
                                        <option value="completed">Completed</option>
                                        <option value="cancelled">Cancelled</option>
                                        <option value="running">Running</option>
                                        <option value="pending">Pending</option>
                                        <option value="conflict">Conflict</option>
                                        <option value="new">New</option>
                                        <option value="requested">Requested</option>
                                    </select>
                                    <select value={challengeLimit} onChange={(e) => Allchallenge(0, e.target.value, challengeStatus)}>
                                        <option value="10">Show 10</option>
                                        <option value="20">Show 20</option>
                                        <option value="50">Show 50</option>
                                        <option value="100">Show 100</option>
                                    </select>
                                </div>
                            <div className="table-responsive">
                                <table className="table user-view-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>ID</th>
                                            <th>Creator</th>
                                            <th>Accepter</th>
                                            <th>Amount</th>
                                            <th>Win/Lose Amt</th>
                                            <th>closing balance</th>
                                            <th>Status</th>
                                            <th>Game Type</th>
                                            <th>Winner</th>
                                            <th>Date</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {challenge.map((game, key) => (
                                            <tr key={key}>
                                                <td>{(challengePage > 0 ? (challengePage - 1) * challengeLimit : 0) + key + 1}</td>
                                                <td>{game._id}</td>
                                                <td><span className="pl-2 ">{game.Created_by.Name}</span></td>
                                                <td><span className="pl-2">{game.Accepetd_By ? game.Accepetd_By.Name : null}</span></td>
                                                <td>{game.Game_Ammount}</td>
                                                <td>
                                                    {game.Winner ? ((user._id == game.Winner._id) ? '+' + game.winnAmount : '-' + game.Game_Ammount) : ((user._id == game.Created_by._id ? game.winnAmount : '-' + game.winnAmount))}
                                                </td>
                                                <td>{game.Winner ? ((user._id == game.Winner._id) ? game.Winner_closingbalance : game.Loser_closingbalance) : ((user._id == game.Created_by._id ? game.Loser_closingbalance : game.Winner_closingbalance))}</td>
                                                <td className='text-primary font-weight-bold'>{game.Status}</td>
                                                <td>{game.Game_type}</td>
                                                <td>{game.Winner ? game.Winner.Name : null}</td>
                                                <td>{dateFormat(game.updatedAt).split(',')[0]} </td>
                                                <td>
                                                    <Link type='button' className="btn-custom btn-purple" style={{ padding: '5px 10px', fontSize: '0.75rem' }} to={`/view/${game._id}`}>View</Link>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {challengeTotalPages > 1 && (
                                <div className="pagination-wrapper">
                                    <ReactPaginate
                                        previousLabel={"←"}
                                        nextLabel={"→"}
                                        breakLabel={"..."}
                                        pageCount={challengeTotalPages}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={2}
                                        onPageChange={(data) => Allchallenge(data.selected + 1, challengeLimit, challengeStatus)}
                                        containerClassName={"pagination"}
                                        pageClassName={"page-item"}
                                        activeClassName={"active"}
                                        forcePage={challengePage > 0 ? challengePage - 1 : 0}
                                    />
                                </div>
                            )}
                            </div>
                        )}
                        {/* 2. Deposit History */}
                        {Boolean(txn) && (
                            <div>
                                <div className="tab-toolbar">
                                    <select value={txnLimit} onChange={(e) => transactionHis(0, e.target.value)}>
                                        <option value="10">Show 10</option>
                                        <option value="20">Show 20</option>
                                        <option value="50">Show 50</option>
                                        <option value="100">Show 100</option>
                                    </select>
                                </div>
                            <div className="table-responsive">
                                <table className="table user-view-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>ID</th>
                                            <th>Amount</th>
                                            <th>Closing balance</th>
                                            <th>Status</th>
                                            <th>Payment gatway</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {txn.map((data, key) => (
                                            <tr key={key}>
                                                <td>{(txnPage > 0 ? (txnPage - 1) * txnLimit : 0) + key + 1}</td>
                                                <td>{data._id}</td>
                                                <td>{data.amount}</td>
                                                <td>{data.closing_balance}</td>
                                                <td className='font-weight-bold text-success'>{data.status}</td>
                                                <td>{(data.payment_gatway) ? data.payment_gatway : ''}</td>
                                                <td>{dateFormat(data.updatedAt).split(',')[0]} </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {txnTotalPages > 1 && (
                                <div className="pagination-wrapper">
                                    <ReactPaginate
                                        previousLabel={"←"}
                                        nextLabel={"→"}
                                        breakLabel={"..."}
                                        pageCount={txnTotalPages}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={2}
                                        onPageChange={(data) => transactionHis(data.selected + 1, txnLimit)}
                                        containerClassName={"pagination"}
                                        pageClassName={"page-item"}
                                        activeClassName={"active"}
                                        forcePage={txnPage > 0 ? txnPage - 1 : 0}
                                    />
                                </div>
                            )}
                            </div>
                        )}
                        {/* 3. Withdrawal History */}
                        {Boolean(txnwith) && (
                            <div>
                                <div className="tab-toolbar">
                                    <select value={txnwithLimit} onChange={(e) => withdrawalHis(0, e.target.value)}>
                                        <option value="10">Show 10</option>
                                        <option value="20">Show 20</option>
                                        <option value="50">Show 50</option>
                                        <option value="100">Show 100</option>
                                    </select>
                                </div>
                            <div className="table-responsive">
                                <table className="table user-view-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>ID</th>
                                            <th>type</th>
                                            <th>Amount</th>
                                            <th>Closing balance</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {txnwith && txnwith.map((data, key) => (
                                            <tr key={key}>
                                                <td>{(txnwithPage > 0 ? (txnwithPage - 1) * txnwithLimit : 0) + key + 1}</td>
                                                <td>{data._id}</td>
                                                <td><span className="pl-2">{data.Withdraw_type}</span></td>
                                                <td>{data.amount}</td>
                                                <td>{data.closing_balance}</td>
                                                <td className='font-weight-bold text-success'>{data.status}</td>
                                                <td>
                                                    {(data.status != 'SUCCESS' && data.amount == user.withdraw_holdbalance) ? <button className="btn-custom btn-red" onClick={() => checkfailedpayout(data._id, data.referenceId)} >Check {data.payment_gatway}</button> : 'Checked'}
                                                </td>
                                                <td>{dateFormat(data.updatedAt).split(',')[0]}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {txnwithTotalPages > 1 && (
                                <div className="pagination-wrapper">
                                    <ReactPaginate
                                        previousLabel={"←"}
                                        nextLabel={"→"}
                                        breakLabel={"..."}
                                        pageCount={txnwithTotalPages}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={2}
                                        onPageChange={(data) => withdrawalHis(data.selected + 1, txnwithLimit)}
                                        containerClassName={"pagination"}
                                        pageClassName={"page-item"}
                                        activeClassName={"active"}
                                        forcePage={txnwithPage > 0 ? txnwithPage - 1 : 0}
                                    />
                                </div>
                            )}
                            </div>
                        )}
                        {/* 4. Referral History */}
                        {Boolean(referral) && (
                            <div>
                                <div className="tab-toolbar">
                                    <select value={referralLimit} onChange={(e) => referralHis(0, e.target.value)}>
                                        <option value="10">Show 10</option>
                                        <option value="20">Show 20</option>
                                        <option value="50">Show 50</option>
                                        <option value="100">Show 100</option>
                                    </select>
                                </div>
                            <div className="table-responsive">
                                <table className="table user-view-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>ID</th>
                                            <th>Earned by</th>
                                            <th>Amount</th>
                                            <th>Closing balance</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {referral.map((data, key) => (
                                            <tr key={key}>
                                                <td>{(referralPage > 0 ? (referralPage - 1) * referralLimit : 0) + key + 1}</td>
                                                <td>{data._id}</td>
                                                <td>{data.earned_from.Name}</td>
                                                <td>{data.amount}</td>
                                                <td>{data.closing_balance}</td>
                                                <td>{dateFormat(data.updatedAt).split(',')[0]} </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {referralTotalPages > 1 && (
                                <div className="pagination-wrapper">
                                    <ReactPaginate
                                        previousLabel={"←"}
                                        nextLabel={"→"}
                                        breakLabel={"..."}
                                        pageCount={referralTotalPages}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={2}
                                        onPageChange={(data) => referralHis(data.selected + 1, referralLimit)}
                                        containerClassName={"pagination"}
                                        pageClassName={"page-item"}
                                        activeClassName={"active"}
                                        forcePage={referralPage > 0 ? referralPage - 1 : 0}
                                    />
                                </div>
                            )}
                            </div>
                        )}
                        {/* 5. Bonus History (New) */}
                        {Boolean(bonusHis) && (
                            <div>
                                <div className="tab-toolbar">
                                    <select value={bonusLimit} onChange={(e) => getBonusHistory(0, e.target.value)}>
                                        <option value="10">Show 10</option>
                                        <option value="20">Show 20</option>
                                        <option value="50">Show 50</option>
                                        <option value="100">Show 100</option>
                                    </select>
                                </div>
                            <div className="table-responsive">
                                <table className="table user-view-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>ID</th>
                                            <th>Amount</th>
                                            <th>Closing balance</th>
                                            <th>Type</th>
                                            <th>Status</th>
                                            <th>Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bonusHis.map((data, key) => (
                                            <tr key={key}>
                                                <td>{(bonusPage > 0 ? (bonusPage - 1) * bonusLimit : 0) + key + 1}</td>
                                                <td>{data._id}</td>
                                                <td>{data.amount}</td>
                                                <td>{data.closing_balance}</td>
                                                <td>{data.Req_type}</td>
                                                <td className='font-weight-bold text-success'>{data.status}</td>
                                                <td>{dateFormat(data.updatedAt).split(',')[0]} </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {bonusTotalPages > 1 && (
                                <div className="pagination-wrapper">
                                    <ReactPaginate
                                        previousLabel={"←"}
                                        nextLabel={"→"}
                                        breakLabel={"..."}
                                        pageCount={bonusTotalPages}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={2}
                                        onPageChange={(data) => getBonusHistory(data.selected + 1, bonusLimit)}
                                        containerClassName={"pagination"}
                                        pageClassName={"page-item"}
                                        activeClassName={"active"}
                                        forcePage={bonusPage > 0 ? bonusPage - 1 : 0}
                                    />
                                </div>
                            )}
                            </div>
                        )}
                        {/* 5. KYC History */}
                        {Boolean(kyc) && (
                            <div className="table-responsive">
                                <table className="table kyc-view-table">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>ID</th>
                                            <th>Doc name</th>
                                            <th>Aadhar no</th>
                                            <th>DOB</th>
                                            <th>Document-Front</th>
                                            <th>Document-Back</th>
                                            <th>Details</th>
                                            <th>status</th>
                                            <th>Date</th>
                                            <th>Approve or Reject</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {kyc && kyc.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>{item._id}</td>
                                                <td>{item.Name}</td>
                                                <td>{item.Number}</td>
                                                <td>{item.DOB}</td>
                                                <td>
                                                    {item.front && (
                                                        <div className="img-panel">
                                                            <OptimizedImage 
                                                                className="img" 
                                                                src={baseUrl + `${item.front}`} 
                                                                alt="kyc" 
                                                                style={{ borderRadius: '5px' }} 
                                                                width="4rem"
                                                                height="4rem"
                                                            />
                                                        </div>
                                                    )}
                                                    {item.alldata && (
                                                        <div className="img-panel">
                                                            <OptimizedImage 
                                                                className="img" 
                                                                src={`data:image/png;base64,${item.alldata.profile_image}`} 
                                                                alt="kyc" 
                                                                style={{ borderRadius: '5px' }} 
                                                                width="4rem"
                                                                height="4rem"
                                                            />
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    {item.back && (
                                                        <div className="img-panel">
                                                            <OptimizedImage 
                                                                className="img" 
                                                                src={baseUrl + `${item.back}`} 
                                                                alt="kyc" 
                                                                style={{ borderRadius: '5px' }} 
                                                                width="4rem"
                                                                height="4rem"
                                                            />
                                                        </div>
                                                    )}
                                                </td>
                                                <td>
                                                    {item.alldata && (
                                                        <div style={{ fontSize: '0.8rem' }}>
                                                            <p>Care_of: {item.alldata.care_of},</p>
                                                            <p>Landmark: {item.alldata.address.landmark},</p>
                                                            <p>Dist: {item.alldata.address.dist},</p>
                                                            <p>State: {item.alldata.address.state},</p>
                                                            <p>{item.alldata.address.po}, {item.alldata.address.loc}, {item.alldata.address.country}</p>
                                                        </div>
                                                    )}
                                                </td>
                                                <td><span className={(item.verified === "reject") ? 'status-badge st-danger' : 'status-badge st-success'}>{item.verified}</span> </td>
                                                <td>{dateFormat(item.updatedAt).split(',')[0]} </td>
                                                <td style={{ display: 'flex', gap: '5px' }}>
                                                    <button className="btn-custom btn-green" disabled={(item.verified === "verified")} onClick={() => update(item._id)}>Approve</button>
                                                    <button className="btn-custom btn-red" disabled={(item.verified === "verified")} onClick={() => deletedata(item._id)}>Reject</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    )
}
